export default __webpack_public_path__ + "static/media/google-logo.c6ed7f7b.svg";